<script setup lang="ts">
import BottomSheetInternal from './BottomSheetInternal.vue';
import { bottomSheets } from '@composable/useBottomSheet';
</script>

<template>
    <ClientOnly>
        <BottomSheetInternal
            v-for="bottomSheet in bottomSheets"
            :key="bottomSheet.name"
            :bottom-sheet
        />
    </ClientOnly>
</template>
